import { createAction } from "@reduxjs/toolkit";
import { CreateAccessesToModels } from "../../@shared/Models/AccessModels";

export const openAccessModel = createAction<string>('openAccessModel');
export const closeAccessModel = createAction('closeAccessModel');
export const updateAccessModel = createAction<CreateAccessesToModels>('updateAccessModel');
export const removeAccessModel = createAction<string>('removeAccessModel');
export const searchAccessModel = createAction<{ str: string, id: string }>('searchAccessModel');





